// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"770":"5b20cb73","886":"5b20cb73"}[chunkId] + ".chunk.css";
};